import { App } from "vue";
import { type AdService, useAdService } from "@/composables/ad-service";

export const adServiceSymbol = Symbol( 'ad-service' );

/**
 * Usage (from component):
 *      ...
 *      const adService = inject< AdService >( adServiceSymbol ) as AdService;
 *      ...
 *      <div>
 *          ...
 *          <BannerAd :meta="adService.bannerAds" />
 *          ...
 *     </div>
 */
const AdServicePlugin = {
    install( app: App< Element > ) {
        // Register the Category Filter provider
        app.provide< AdService >( adServiceSymbol, useAdService() );
    }
}

export default AdServicePlugin;